import { Component, Inject, OnInit } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { finalize, catchError, of as observableOf } from 'rxjs';
import { PatientRegistrationService } from 'src/app/pages/patient-registration/patient-registration.service';
import { DialogService } from '../dialog.service';
import { LanguageService } from '../../language/language.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from "src/environments/environment";
import * as _ from 'lodash';
import * as moment from "moment";

@Component({
  selector: 'esc-coupon-list-dialog',
  templateUrl: './coupon-list-dialog.component.html',
  styleUrls: ['./coupon-list-dialog.component.scss']
})
export class CouponListDialogComponent implements OnInit {

  public displayedColumns: string[] = ['campaign', 'quantity', 'product_names', 'actions'];
  public listData = []
  public loading: Boolean = false;
  public error: Boolean = false;

  constructor(
    public dialogRef: MatDialogRef<CouponListDialogComponent>,
    public media: MediaObserver,
    private patientRegistrationService: PatientRegistrationService,
    private dialogService: DialogService,
    private languageService: LanguageService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.getData()
  }

  getData() {
    if (this.loading) {
      return;
    }
    this.loading = true;
    this.error = false;

    this.patientRegistrationService.listCoupons({ email: this.data.email, uuid: this.data.uuid }).pipe(
      finalize(() => {
        this.loading = false;
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }

        if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
          this.error = true;
          this.listData = [];
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {}))
          return;
        }
        if (_.has(res, 'value') && (res.value == "Success")) {
          this.listData = this.listData.concat(res.data);
        } else {
          this.listData = [];
        }
      }, err => {
        if (environment.showLogs) {
          console.error(err);
        }
        if (this.listData.length == 0) {
          this.error = true;
        } else {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {}));
        }
        return observableOf(null);
      });
  }

}
